export enum ItemGroupEnum {
    FG = "FG",
    RM = "RM",


  }


  export const  ItemGroupDisplayvalue =[
    {name:'FG', displayVal:"FG"},
   {name: 'RM' ,displayVal:"RM"},


  ]